import React, { Suspense } from "react";
import { ExitContainer } from "../Containers/Exit";
export const ExitPage = () => {
  return (
    <Suspense fallback={"loading"}>
      <ExitContainer />
    </Suspense>
  );
};
